export default function capitalize(str) {
   if (!str) return str
   const capitalizedStr = str.substr(0, 1).toUpperCase() + str.substr(1)
   return capitalizedStr
}
